import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function GalleryStoryEditor({ item, onSaved }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(item.story || item.subtitle || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    const fd = new FormData(); fd.append("story", text);
    try { await api.patch(`/admin/gallery/${item.id}`, fd); toast.success("Write-up saved — it shows on the project page"); setOpen(false); onSaved(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Couldn't save"); }
    finally { setBusy(false); }
  };
  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="text-[11px] rounded-full px-2.5 py-1 border border-slate-700 text-slate-300 hover:border-cyan-400 transition-colors" data-testid={`gallery-story-edit-${item.id}`}>
        {item.story ? "Edit write-up" : "Add project write-up"}
      </button>
    );
  }
  return (
    <div className="mt-2 space-y-2" data-testid={`gallery-story-editor-${item.id}`}>
      <textarea className="dg-input text-sm" rows={5} value={text} onChange={(e) => setText(e.target.value)} maxLength={4000}
        placeholder="What David did on this job — the problem, the gear, the result. Blank lines make new paragraphs." data-testid={`gallery-story-input-${item.id}`} />
      <div className="flex items-center gap-2 text-xs">
        <button type="button" onClick={save} disabled={busy} className="dg-btn-primary rounded-full px-4 py-1.5 disabled:opacity-50" data-testid={`gallery-story-save-${item.id}`}>{busy ? "Saving…" : "Save write-up"}</button>
        <button type="button" onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-200">Cancel</button>
        <a href={`/project/${item.id}`} target="_blank" rel="noreferrer" className="ml-auto dg-link">Preview page ↗</a>
      </div>
    </div>
  );
}
